import { Response } from 'express';
import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';

import { TState } from '@r1-frontend/entities/stores/auth/reducer';

import { fetchClientInfo } from './clientInfo';

/**
 * Получаем данные для ЛК авторизованного
 */
/** @deprecated use frontend/apps/b2c-domru/src/store/actions/auth/getInfoAll.ts **/
export function getClientAll(response?: Response, agreementNumber?: string) {
    return async(dispatch: ThunkDispatch<TState, void, AnyAction>, getState: () => TState) => {
        const { auth } = getState();
        const { clientPaymentLoaded, clientPaymentFetching, clientPersonal } = auth;

        // Не выполняем запрос если данные были загружены ранее
        if (clientPaymentLoaded || clientPaymentFetching || clientPersonal !== null) {
            return;
        }

        await Promise.resolve(
            dispatch(fetchClientInfo(response, agreementNumber)),
        );
    };
}
